import EditPolygon from "../plot/EditPolygon"
import EditBase from "../plot/EditBase"
import { getArea, formatArea } from "./utils/space"
class EditAreaSpace extends EditPolygon {

    constructor(options) {
        super(options);
        this.initCenter=false;
        this.initRotate=false;
    }

    initKeyPoint() {
        var entitiesLabel = this.plot.attrPlot['entitiesLabel'];
        for (let i = 0; i < entitiesLabel.length; i++) {
            var pos = entitiesLabel[i];
            pos.attrPlot = {
                e_index: i,
                [EditBase.ext_id]: this.editGuid,
                [EditBase.ext_keyFlag]: true
            };
        }
        this.plot.attrPlot[EditBase.ext_keyPos] = entitiesLabel; //实体
    }
    
    // initCenterPoint() {
    //     var ext_centerPos = this.plot.attrPlot[EditBase.ext_centerPos];
    //     ext_centerPos.attrPlot = {
    //         [EditBase.ext_centerFlag]: true,
    //         [EditBase.ext_id]: this.editGuid
    //     };
    // }
    translateAll(position) {
        super.translateAll(position);
        this.updateAllLabel();
    }
    rotationAll(position) {
        super.rotationAll(position);
        this.updateAllLabel();
    }
    updateCenter() {
        super.updateCenter();
        this.updateAllLabel();
    }
    updateAllLabel() {
        var positions = this.plot.attrPlot[EditBase.ext_positions];
        var area = getArea(positions);
        var p = this.plot.attrPlot[EditBase.ext_centerPos]; //实体
        p.label.text = `空间面积:${formatArea(area)}`
    }

    hideEdit() {

    }

}

export default EditAreaSpace